import axios from 'axios'
import Tool from '@/utils/tool'
import qs from 'qs'
import Cookie from "js-cookie"
import app from '../main'

const needVerifyRoutes = ['/editor']

var domain = 'laozicloud.com'
if( location.origin.includes( 'laozicloud.net' ) ){
    domain = 'laozicloud.net'
}
if( location.origin.includes( 'localhost' ) ){
    domain = ''
}

// 添加一个请求拦截器
axios.interceptors.request.use(function (config) {

    const unauthRoutes = [
        '/api-auth/oauth/user/token',
        '/api-auth/thirdPartLogin/public/getAliyunAcs',
        '/api-auth/thirdPartLogin/public/userIsExist'
    ]

    if ( unauthRoutes.includes( config.url ) ) {
        // console.log('登录接口不需要令牌')
    } else {
        if ( Cookie.get('authorization') ) {
            config.headers['Authorization'] = 'bearer ' + Cookie.get('authorization')
        }
    }

    config.headers['client-id'] = 'webApp'
    config.headers['client-secret'] = 'webApp'

    const newData = {
        ...config.data
    }

    if ( process.browser ) { //如果是浏览器端 则进行rsa加密
        if ( config.data && config.data.isJson ) {
            config.headers['laozisignedmd5'] = Tool.md5( JSON.stringify(config.data) )
        } else {
            newData.D = Tool.rsa( Tool.serialize(config.data) )
        }
    } else {
        newData.ignore = '2zp8SIiXeF5xseF0'
    }

    if (config.data && config.data.isJson) {
        config.headers['Content-Type'] = 'application/json' //设置请求头
    } else {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        config.data = qs.stringify(newData) //提交数据转换成form Data格式
    }
    return  config
})

var MessageHandler
// 添加一个响应拦截器
axios.interceptors.response.use( response => {
    return new Promise(function (resolve, reject) {
        if ( response.status === 200 ) {
            if ( response.data.resp_code == 401 ) {
                Cookie.remove( 'loginId', { domain })
                // Tool.toLoginPage( true )
                // var needRedirect = needVerifyRoutes.reduce((acculate, currentVal) => {
                //     acculate = path.startsWith(currentVal) || acculate
                //     return acculate
                // }, false)
                // if (needRedirect){
                //     console.log('唤起登陆程序')
                // }
                //@ts-ignore
                app.$root.loginVisible = true
                if( !MessageHandler ){
                    MessageHandler = app.$message.warning({
                        message: '登陆失效，请重新登陆',
                        type: 'warning',
                        duration: 3000,
                        onClose: function(){
                            MessageHandler = null
                        }
                    })
                }                
            }else{
                resolve(response.data)
            }
        } else {
            reject(response)
        }
    })
},
error => {
    return error
})

export class ResponseCode {
    static SUCCESS = 60000
}

export default axios

